/**
 * File jumplink.js.
 * Handles jumplink scroll behavior and Segment event
 */

const jumplinks = document.querySelectorAll('.jumplink--link');

function handleJumplink(e) {
  sscmsPreventDefault(e);
  const name = e.target.getAttribute('href').replace('#', '');
  const anchor = document.querySelector('a[name=' + name + ']');
  const text = e.target.textContent;
  const location = window.location.href;
  const properties = {
    jumplink_text: text,
    jumplink_location: location
  };

  segment('track', 'Jumplink Tapped', properties);

  anchor.scrollIntoView({
    behavior: 'smooth'
  });
}

if (jumplinks.length > 0) {
  for (let j = 0; j < jumplinks.length; j++) {
    jumplinks[j].addEventListener('click', handleJumplink)
  }
}
